var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDashboardImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.336,
    height: 24.337,
    viewBox: "0 0 24.336 24.337",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.932,10.537,31.081,5.672A12.165,12.165,0,0,0,11.747,4.032Z",
    transform: "translate(-8.625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.489,23.827A12.167,12.167,0,0,0,2.67,37.265L10,29.853Z",
    transform: "translate(0 -17.494)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.921,36.034,17.6,44.453a12.166,12.166,0,0,0,19-13.537Z",
    transform: "translate(-12.922 -22.699)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboardImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboardImg.b50f34a2.svg";
export { ForwardRef as ReactComponent };